import { FormActionButton } from '@workwave-tidal/core/form'

import { useEditingStateWithCtx } from '@/atoms'
import { form } from './formState'

import { useTexts } from '../hooks/useTexts'

export function FormFooter() {
  const { resetEditing } = useEditingStateWithCtx('customerNotifications')

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()
  const texts = useTexts()

  return (
    <>
      <FormActionButton
        label={texts.cancel}
        size="medium"
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
        onClick={resetEditing}
      />
      <FormActionButton
        size="medium"
        type="submit"
        label={texts.save}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
        variant="contained"
        loading={submitting || validating}
        disabled={status === 'pristine' || validating || submitting}
      />
    </>
  )
}
